<template>
  <div>
    <Tables ref="tableGrid"
              :columns="headTable"
              :showSearch="false"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              v-on:Load="onLoad"
            >
              <tr v-for="obj in this.objList" v-bind:key="obj.id">
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',obj)" :status="obj.status" :value="obj.obraNome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',obj)" :status="obj.status" :value="obj.codigoObra" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',obj)" :status="obj.status" :value="obj.responsavelNome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',obj)" :status="obj.status" :value="obj.numeroContrato" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',obj)" :status="obj.status" :value="obj.nome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',obj)" :status="obj.status" :value="obj.dataVistoriaFormatadaNotHour" />
                <TableColumn v-on:Edit="onSelect(obj)" :newStateVistoria="true" :colorStatusVistoria="getclassstatus(obj.statusvistoria)" :descriptionNewStatusVistoria="formatStatusVistoria(obj.statusvistoria)" :fontColorStatusVistoria="getclassstatuFont(obj.statusvistoria)" style="font-weight: bold; font-size: 9px;"></TableColumn>
                <TableColumn :IsDocumentActions="true" :HasTrasparente="obj.statusvistoria != 1 ? true : false" :HasAproved="obj.statusvistoria == 1" v-on:aprovedIten="openAprovedVistoria(obj.id)" :HasDocumentDelete="true" v-on:Delete="onDelete(obj)" :status="obj.status" />
              </tr>
    </Tables>
    <b-modal ref="aprovedVistoria"
        size="md"
        centered
        title="Aprovar"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        body-class="rounded-bottom-1rem"
        content-class="rounded-1rem"
        >
        <template #modal-title>
            <div class="header-title">APROVAR VISTORIA</div>
        </template>
          <div class="container-new-template">
            <i class="fas fa-thumbs-up ml-2 text-secundary" style="color: green; text-align: center; font-size: 45px;width: 100%; margin: 1rem;"></i>

            <div class="font">Deseja proseguir com a aprovação da <strong style="font: bold;">vistoria</strong>?</div>

            <div class="d-flex container_cancel_save">
              <div class="cancelar">
                  <button class="button-cancel" @click="closeAprovedVistoria">CANCELAR</button>
              </div>
              <div class="criar">
                <button class="button-save" @click="changeStatus(3)">APROVAR</button>
              </div>
            </div>
          </div>
        </b-modal>
  </div>
</template>

<script>
import tableSurvey from './tableSurvey.js'
export default tableSurvey
</script>
<style scoped>
.titulo-modal{
  color: white;
  font-family: 'Segoe UI';
}
.statusApro{
  color: white;
  background: green;
  align-items: center;
  font-size: 15px;
  border-radius: 2px;
}
.statusAguCore {
  color: white;
  background: rgb(233, 8, 46);
  align-items: center;
  font-size: 15px;
  border-radius: 2px;

}
.statusAguApro{
  color: white;
  background: rgb(19, 4, 235);
  align-items: center;
  font-size: 15px;
  border-radius: 2px;
}

.statusNotEn{
  color: white;
  background: rgb(192, 192, 35);
  align-items: center;
  font-size: 15px;
  border-radius: 2px;
}
.container-new-template{
    width: 100%;
  }
  .font {
    width: 100%;
    line-height: 1.5rem ;
    text-align: center;
    font-family: 'Segoe UI';
    font-size: 18px;
    color: #505050;
  }
  .header-title{
    color: white;
    font-size: 16px;
    font-weight: bold;
    font-family: 'Segoe UI';
  }
  .negrito {
    font-weight: bold;
  }
   .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 10px;
   }
  .button-cancel,
  .button-save{
    margin-top: 1rem;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 170px;
    height: 35px;
    font-family: 'Segoe UI';
    font-size: 12px;
    font-weight: bold;
  }
  .button-cancel{
    background-color: #b60000;
    color: white;
  }
  .button-save{
    background-color: darkgreen;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/Survey/components/tableSurvey/tableSurvey.vue